import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { startAppTour } from '../utils/appTour'
import {
  Layout,
  Menu,
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Upload,
  message,
  Spin,
  Card,
  List,
  Modal,
  Result
} from 'antd'
import styled from 'styled-components'
import {
  PlusOutlined,
  LockOutlined,
  CheckOutlined,
  CrownOutlined,
  HomeOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  SettingOutlined,
  GoogleOutlined,
  CreditCardOutlined,
  DragOutlined,
  CloseOutlined
} from '@ant-design/icons'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
  useSortable,
  sortableKeyboardCoordinates
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FaMoneyBillWave } from 'react-icons/fa'
import { TbCalendarCancel } from 'react-icons/tb'
import { RiNotificationBadgeFill } from 'react-icons/ri'
import { MessageOutlined } from '@ant-design/icons'
import BusinessHours from '../components/BusinessHours'
import CompanyDaysOff from '../components/CompanyDaysOff'
import AppointmentSettings from '../components/AppointmentSettings'
import DepositSettings from '../components/DepositSettings'
import PaymentSettings from '../components/PaymentSettings'
import PaymentFeeSettings from '../components/PaymentFeeSettings'
import LineSettings from '../components/LineSettings'
import MembershipInfoPage from './MembershipInfoPage'
import GoogleCalendarSettingsPage from './GoogleCalendarSettingsPage'
import MyLineNotificationPage from './MyLineNotificationPage'
import { PHOTO_URL } from '../utils/apiutils'
import { categories } from '../utils/utils'
import { useAuth } from '../hooks/AuthContext'
import api from '../utils/api'
import { usePermission } from '../hooks/usePermission'
import dayjs from 'dayjs'

const { Sider, Content } = Layout
const { Option } = Select

// 可拖曳排序的單張照片卡片
const PhotoCardBox = styled.div`
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
  .img-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
  }
  .img-wrap img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  .drag-handle {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
  }
  .remove-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background: rgba(255, 0, 0, 0.7);
    }
  }
`
const PhotoListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`
const UploadTrigger = styled.div`
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
  transition: all 0.2s;
  &:hover {
    border-color: #d5728a;
    color: #d5728a;
  }
`

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  background: #fff;
`

const ContentWrapper = styled.div`
  padding: 12px;
  background: #fff;
  min-height: calc(100vh - 24px);

  @media (max-width: 820px) {
    min-height: calc(100vh - 72px);
  }
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
`
const StyledButton = styled(Button)`
  width: 100%;
  height: 50px;
  font-size: 16px;

  &.ant-btn-primary[disabled] {
    background: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
  }

  &.ant-btn-primary.ant-btn-loading {
    opacity: 0.8;
  }
`

const MobileMenuWrapper = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  background-color: #fcfcfc;
  padding: 10px 5px;
  border-radius: 10px 10px 0 0;

  &::-webkit-scrollbar {
    display: none;
  }
`

const MobileMenuItem = styled.div`
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
  color: ${(props) => (props.active ? '#d5728a' : 'rgba(0, 0, 0, 0.65)')};
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  position: relative;
  transition: all 0.3s;

  &:hover {
    color: #d5728a;
  }

  .icon {
    margin-right: 8px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #d5728a;
    transform: scaleX(${(props) => (props.active ? 1 : 0)});
    transform-origin: ${(props) => (props.active ? 'left' : 'right')};
    transition: transform 0.3s ease-in-out;
  }
`

const StyledCard = styled(Card)`
  background: #fff;

  .ant-card-body {
    padding: 0;
  }
`

const FeatureLockCard = styled(Card)`
  background: linear-gradient(135deg, #fffbe6 0%, #fff7e6 100%);
  border: none;
  border-radius: 12px;
  overflow: hidden;

  .ant-card-body {
    padding: 24px;
  }

  .lock-content {
    text-align: center;
    padding: 32px 24px;
  }

  .lock-icon {
    font-size: 48px;
    color: #ffa940;
    margin-bottom: 16px;
  }

  .lock-title {
    color: #434343;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .lock-description {
    color: #8c8c8c;
    font-size: 14px;
    margin-bottom: 24px;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  .feature-list {
    text-align: left;
    max-width: 320px;
    margin: 24px auto;

    .feature-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: #595959;

      .anticon {
        color: #52c41a;
        margin-right: 8px;
      }
    }
  }

  @media (max-width: 576px) {
    .lock-content {
      padding: 24px 16px;
    }

    .lock-title {
      font-size: 18px;
    }

    .lock-description {
      font-size: 13px;
      max-width: 100%;
    }
  }
`

// 修改密碼區塊（商家自行修改登入密碼）
const ChangePasswordSection = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      await api.put('/api/business_B/change-password', {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword
      })
      message.success('密碼已成功更新，下次登入請使用新密碼')
      form.resetFields()
    } catch (err) {
      const errMsg = err.response?.data?.error || '修改密碼失敗，請稍後再試'
      message.error(errMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card
      title={
        <span>
          <LockOutlined style={{ marginRight: 8 }} />
          修改登入密碼
        </span>
      }
      style={{ maxWidth: 480, margin: '0 auto', borderRadius: 12 }}
    >
      <Form form={form} layout='vertical' onFinish={handleSubmit} size='large'>
        <Form.Item
          name='oldPassword'
          label='目前密碼'
          rules={[{ required: true, message: '請輸入目前密碼' }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder='請輸入目前密碼' />
        </Form.Item>

        <Form.Item
          name='newPassword'
          label='新密碼'
          rules={[
            { required: true, message: '請輸入新密碼' },
            { min: 6, message: '密碼長度至少 6 個字符' }
          ]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder='至少 6 個字符' />
        </Form.Item>

        <Form.Item
          name='confirmPassword'
          label='確認新密碼'
          dependencies={['newPassword']}
          rules={[
            { required: true, message: '請再次輸入新密碼' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error('兩次輸入的密碼不一致'))
              }
            })
          ]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder='請再次輸入新密碼' />
        </Form.Item>

        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            loading={loading}
            block
            icon={<LockOutlined />}
          >
            確認修改密碼
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

const SettingsPage = () => {
  const { section = 'info' } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 820)
  const { user } = useAuth()
  const businessId = user.businessId
  const { can } = usePermission()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 820)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // 处理 Google Calendar 回调参数和默认 section
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const calendarConnected = urlParams.get('calendar_connected')
    const calendarError = urlParams.get('calendar_error')

    // 如果有 Google Calendar 回调参数，自动导航到 calendar 页面
    if (calendarConnected || calendarError) {
      if (section !== 'calendar') {
        const queryString = location.search
        navigate(`/settings/calendar${queryString}`, { replace: true })
      }
      return
    }

    // 如果没有 section 参数，默认显示 info
    if (!section) {
      navigate('/settings/info', { replace: true })
    }
  }, [location.search, section, navigate])

  const handleMenuClick = (key) => {
    navigate(`/settings/${key}`)
  }

  const renderContent = () => {
    const currentSection = section || 'info'
    switch (currentSection) {
      case 'info':
        return <StoreInfoForm />
      case 'hours':
        return <BusinessHours />
      case 'daysOff':
        return <CompanyDaysOff />
      case 'appointment':
        return <AppointmentSettings />
      case 'deposit':
        return <DepositSettings businessId={businessId} />
      case 'booking':
        return <BookingInstructionsForm />
      case 'cancel':
        return <CancellationPolicyForm />
      case 'calendar':
        return <GoogleCalendarSettingsPage />
      case 'membership':
        return <MembershipInfoPage />
      case 'payment':
        return <PaymentSettings />
      case 'paymentFee':
        // 沒權限就當這個分頁不存在（直接打網址也進不來；後端另有把關）
        return can('paymentFee:manage') ? (
          <PaymentFeeSettings businessId={businessId} />
        ) : (
          <StoreInfoForm />
        )
      case 'line':
        return <LineSettings />
      case 'myLineNotify':
        return <MyLineNotificationPage />
      case 'password':
        return <ChangePasswordSection />
      default:
        return <StoreInfoForm />
    }
  }

  const menuItems = [
    { key: 'info', icon: <HomeOutlined />, label: '店家資訊' },
    { key: 'hours', icon: <ClockCircleOutlined />, label: '營業時間' },
    { key: 'daysOff', icon: <CalendarOutlined />, label: '休假日設定' },
    { key: 'appointment', icon: <SettingOutlined />, label: '預約設定' },
    { key: 'deposit', icon: <FaMoneyBillWave />, label: '定金設定' },
    { key: 'booking', icon: <RiNotificationBadgeFill />, label: '預約須知' },
    { key: 'cancel', icon: <TbCalendarCancel />, label: '取消規定' },
    { key: 'line', icon: <MessageOutlined />, label: 'LINE 整合' },
    {
      key: 'myLineNotify',
      icon: <MessageOutlined />,
      label: '我的 LINE 通知'
    },
    { key: 'calendar', icon: <GoogleOutlined />, label: 'Google 日曆同步' },
    { key: 'membership', icon: <CrownOutlined />, label: '會員資訊' },
    { key: 'payment', icon: <CreditCardOutlined />, label: '金流設定' },
    // 金流手續費：可開啟「向客人加收服務費」，只有店主與店長看得到
    ...(can('paymentFee:manage')
      ? [
          {
            key: 'paymentFee',
            icon: <CreditCardOutlined />,
            label: '金流手續費'
          }
        ]
      : []),
    { key: 'password', icon: <LockOutlined />, label: '修改密碼' }
  ]

  return (
    <StyledLayout>
      {isMobile && (
        <MobileMenuWrapper>
          {menuItems.map((item) => (
            <MobileMenuItem
              key={item.key}
              active={section === item.key}
              onClick={() => handleMenuClick(item.key)}
            >
              <span className='icon'>{item.icon}</span>
              {item.label}
            </MobileMenuItem>
          ))}
        </MobileMenuWrapper>
      )}
      <Content>
        <ContentWrapper>{renderContent()}</ContentWrapper>
      </Content>
    </StyledLayout>
  )
}

// 單張可排序照片（useSortable 必須在組件內使用）
const SortablePhotoCard = ({ file, onRemove }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: file.uid })
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }
  const thumbUrl = file.thumbUrl || file.url
  return (
    <PhotoCardBox
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <div className='img-wrap'>
        {thumbUrl ? (
          <img src={thumbUrl} alt={file.name || ''} draggable={false} />
        ) : (
          <span style={{ color: '#999' }}>預覽</span>
        )}
      </div>
      <span className='drag-handle' onClick={(e) => e.stopPropagation()}>
        <DragOutlined />
      </span>
      <span
        className='remove-btn'
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
        aria-label='移除'
      >
        <CloseOutlined />
      </span>
    </PhotoCardBox>
  )
}

const StoreInfoForm = () => {
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [deletedPhotos, setDeletedPhotos] = useState([])
  const { user } = useAuth()
  const businessId = user.businessId
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    api
      .get(`/api/business_B/${businessId}`)
      .then((response) => {
        const business = response.data
        form.setFieldsValue({
          name: business.name,
          address: business.address,
          phone: business.phone,
          instagram:
            business.instagram === 'undefined' ? '' : business.instagram,
          facebook: business.facebook === 'undefined' ? '' : business.facebook,
          line: business.line === 'undefined' ? '' : business.line,
          website: business.website === 'undefined' ? '' : business.website,
          serviceType: business.serviceType,
          minprice: business.minprice,
          description: business.description
        })
        if (business.photos && business.photos.length > 0) {
          setFileList(
            business.photos.map((photo, index) => ({
              uid: photo._id,
              name: photo.url.split('/').pop(),
              status: 'done',
              url: `${PHOTO_URL}${photo.url}`
            }))
          )
        }
      })
      .catch((error) => {
        console.error('獲取商家詳情時出錯：', error)
      })
  }, [businessId, form])

  const handleFinish = async (values) => {
    setIsSaving(true)
    const formData = new FormData()

    try {
      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined) {
          formData.append(key, values[key])
        }
      })

      // 處理新上傳的文件
      fileList.forEach((file, index) => {
        if (file.originFileObj) {
          formData.append(`photos`, file.originFileObj)
        } else {
          formData.append(`existingPhotos[${index}]`, file.uid)
        }
      })

      // 處理要刪除的照片
      deletedPhotos.forEach((photoId, index) => {
        formData.append(`deletedPhotos[${index}]`, photoId)
      })

      await api.put(`/api/business_B/${businessId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      message.success('商家信息已更新')
      setDeletedPhotos([])
    } catch (error) {
      message.error('更新失敗，請稍後再試')
      console.error('更新商家信息時出錯：', error)
    } finally {
      setIsSaving(false)
    }
  }

  const beforeUpload = async (file) => {
    const isAllowedType =
      /\.(jpeg|jpg|png|gif|mp4|mov|quicktime|webp|heic|heif|bmp)$/i.test(
        file.name
      )
    const isLt10M = file.size / 1024 / 1024 < 10

    if (!isLt10M) {
      message.error('文件必須小於 10MB！')
      return Upload.LIST_IGNORE
    }

    // HEIC/HEIF 格式直接上傳，由後端處理
    if (/\.(heic|heif)$/i.test(file.name)) {
      // 直接返回 false，允許上傳原始文件
      return false
    }

    if (!isAllowedType) {
      message.error(
        '不支持的文件格式！請上傳 JPEG, JPG, PNG, GIF, MP4, MOV, QuickTime, WebP, HEIC, HEIF 或 BMP 格式的文件。'
      )
      return Upload.LIST_IGNORE
    }

    return false
  }

  const handleUploadChange = ({ fileList: newFileList }) => {
    // 僅用於「新增」：把新選的檔案併入我們的 fileList（由 SortablePhotoCard 負責移除）
    setFileList((prev) => {
      const newlyAdded = (newFileList || []).filter(
        (f) => f.originFileObj && !prev.some((fl) => fl.uid === f.uid)
      )
      if (newlyAdded.length === 0) return prev
      const updated = newlyAdded.map((f) => {
        if (f.originFileObj && /\.(heic|heif)$/i.test(f.name)) {
          return { ...f, type: 'image/jpeg', name: f.name.replace(/\.(heic|heif)$/i, '.jpg') }
        }
        return f
      })
      return [...prev, ...updated].slice(0, 5)
    })
  }

  const handleRemovePhoto = (file) => {
    if (file.originFileObj) {
      setFileList((prev) => prev.filter((f) => f.uid !== file.uid))
    } else {
      setDeletedPhotos((prev) => [...prev, file.uid])
      setFileList((prev) => prev.filter((f) => f.uid !== file.uid))
    }
  }

  const handlePhotoDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) return
    const oldIndex = fileList.findIndex((f) => f.uid === active.id)
    const newIndex = fileList.findIndex((f) => f.uid === over.id)
    if (oldIndex === -1 || newIndex === -1) return
    setFileList(arrayMove(fileList, oldIndex, newIndex))
  }

  const photoSensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  )

  const navigate = useNavigate()
  return (
    <Form form={form} layout='vertical' onFinish={handleFinish}>
      <Row gutter={[16, 16]}>
        <Col span={24} style={{ marginBottom: 8 }}>
          <Button
            type='link'
            onClick={() => startAppTour(navigate, 0, businessId)}
            style={{ padding: 0 }}
          >
            觀看系統教學
          </Button>
        </Col>
        <Col xs={24} sm={12}>
          <div data-tour='store-name'>
            <Form.Item
              name='name'
              label='商店名稱'
              rules={[{ required: true, message: '請輸入商店名稱' }]}
            >
              <Input />
            </Form.Item>
          </div>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name='address'
            label='地址'
            rules={[{ required: true, message: '請輸入地址' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='phone'
            label='電話'
            rules={[{ required: true, message: '請輸入電話' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name='instagram' label='Instagram (網址)'>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={8}>
          <Form.Item name='facebook' label='Facebook (網址)'>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item name='line' label='Line (網址)'>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item name='website' label='網站'>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item
            name='serviceType'
            label='服務類型'
            rules={[{ required: true, message: '請選擇服務類型' }]}
          >
            <Select mode='multiple'>
              {categories
                .filter((category) => category.type !== 'all')
                .map((category) => (
                  <Option key={category.type} value={category.type}>
                    {category.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name='minprice' label='基本服務價格（新臺幣）'>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <div data-tour='store-description'>
            <Form.Item name='description' label='店家介紹'>
              <Input.TextArea rows={4} />
            </Form.Item>
          </div>
        </Col>
        <Col xs={24} sm={12}>
          <div data-tour='store-photos'>
            <Form.Item name='photos' label='上傳照片'>
              <div>
                <DndContext
                  sensors={photoSensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handlePhotoDragEnd}
                >
                  <PhotoListWrapper>
                    <SortableContext
                      items={fileList.map((f) => f.uid)}
                      strategy={rectSortingStrategy}
                    >
                      {fileList.map((file) => (
                        <SortablePhotoCard
                          key={file.uid}
                          file={file}
                          onRemove={() => handleRemovePhoto(file)}
                        />
                      ))}
                    </SortableContext>
                    {fileList.length < 5 && (
                      <Upload
                        fileList={[]}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={handleUploadChange}
                        multiple
                        accept='.jpeg,.jpg,.png,.gif,.webp,.heic,.heif,.bmp,.mp4,.mov'
                      >
                        <UploadTrigger>
                          <PlusOutlined style={{ fontSize: 20 }} />
                          <div style={{ marginTop: 4 }}>上傳</div>
                        </UploadTrigger>
                      </Upload>
                    )}
                  </PhotoListWrapper>
                </DndContext>
              </div>
            </Form.Item>
          </div>
          <div
            style={{
              marginTop: '-20px',
              marginBottom: '20px',
              color: '#888'
            }}
          >
            最多上傳 5 張，每張不超過 10MB；可拖曳調整顯示順序
          </div>
        </Col>
      </Row>
      <Form.Item>
        <ButtonGroup>
          <StyledButton type='primary' htmlType='submit' loading={isSaving}>
            {isSaving ? '保存中...' : '保存'}
          </StyledButton>
        </ButtonGroup>
      </Form.Item>
    </Form>
  )
}

const BookingInstructionsForm = () => {
  const [form] = Form.useForm()
  const { user } = useAuth()
  const businessId = user.businessId

  useEffect(() => {
    api
      .get(`/api/business_B/${businessId}`)
      .then((response) => {
        const business = response.data
        form.setFieldsValue({
          bookingInstructions: business.bookingInstructions || ''
        })
      })
      .catch((error) => {
        console.error('獲取預約須知時出錯：', error)
      })
  }, [businessId, form])

  const handleFinish = (values) => {
    api
      .put(`/api/business_B/${businessId}/booking-policies`, {
        bookingInstructions: values.bookingInstructions
      })
      .then((response) => {
        message.success('預約須知已更新')
      })
      .catch((error) => {
        message.error('更新失敗，請稍後再試')
        console.error('更新預約須知時出錯：', error)
      })
  }

  return (
    <div data-tour='booking-instructions'>
      <Form
        form={form}
        layout='vertical'
        onFinish={handleFinish}
        style={{ height: '100vh' }}
      >
        <Form.Item
          name='bookingInstructions'
          label='預約須知'
          rules={[{ required: true, message: '請輸入預約須知' }]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item>
          <ButtonGroup>
            <StyledButton type='primary' htmlType='submit'>
              保存
            </StyledButton>
          </ButtonGroup>
        </Form.Item>
      </Form>
    </div>
  )
}

const CancellationPolicyForm = () => {
  const [form] = Form.useForm()
  const { user } = useAuth()
  const businessId = user.businessId

  useEffect(() => {
    api
      .get(`/api/business_B/${businessId}`)
      .then((response) => {
        const business = response.data
        form.setFieldsValue({
          cancellationPolicy: business.cancellationPolicy || ''
        })
      })
      .catch((error) => {
        console.error('獲取取消規定時出錯：', error)
      })
  }, [businessId, form])

  const handleFinish = (values) => {
    api
      .put(`/api/business_B/${businessId}/booking-policies`, {
        cancellationPolicy: values.cancellationPolicy
      })
      .then((response) => {
        message.success('取消規定已更新')
      })
      .catch((error) => {
        message.error('更新失敗，請稍後再試')
        console.error('更新取消規定時出錯：', error)
      })
  }

  return (
    <div data-tour='cancellation-policy'>
      <Form
        form={form}
        layout='vertical'
        onFinish={handleFinish}
        style={{ height: '100vh' }}
      >
        <Form.Item
          name='cancellationPolicy'
          label='取消規定'
          rules={[{ required: true, message: '請輸入取消規定' }]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item>
          <ButtonGroup>
            <StyledButton type='primary' htmlType='submit'>
              保存
            </StyledButton>
          </ButtonGroup>
        </Form.Item>
      </Form>
    </div>
  )
}

export default SettingsPage
